import React from 'react';
import Logos from '@/components/logo';
import { getSite, PLATFORM } from '@/common/constants/platform-constants';
import s from './index.module.less';
import {
  SiteExternalModule, SiteHelpDocsLink, SiteRules,
} from './method';
import PromotionProductions from './promotion-productions';

const productsWoa = [
  { label: 'FlexibleCode', link: '//flexiblecode.woa.com' },
  { label: 'TestX', link: '//testx.woa.com' },
  { label: 'TestSolar', link: '//testsolar.woa.com' },
  { label: 'JobMatrix', link: '//codematrix.pages.woa.com/#/apps/fc/jobmatrix/docs/index' },
  { label: 'CodeMatrix', link: '//codematrix.pages.woa.com/#/' },
  { label: 'TCA', link: '//tca.woa.com/' },
];

const products = [
  { label: 'IAC', link: 'https://cloud.tencent.com/product/iac' },
  { label: 'TCA', link: 'https://cloud.tencent.com/product/tcap' },
];

const CSS_PROPERTIES = {
  width: 1280,
};

const PageFooter = () => (
  <div className={s.pageFooter}>
    {SiteExternalModule[getSite()]}
    <div className={s.promotion} style={CSS_PROPERTIES}>
      <div className={s.product}>
        <div className={s.title}>产品推荐</div>
        <div className={s.list}>
          {
            (getSite() === PLATFORM.STANDALONE_WOA ? productsWoa : products).map(item => <a key={item.label} href={item.link} target="_blank" rel="noreferrer">{item.label}</a>)
          }
        </div>
      </div>
      <div className={s.help}>
        <div className={s.title}>帮助与支持</div>
        <div className={s.list}>
          {
            SiteHelpDocsLink[getSite()].map(item => <a key={item.label} href={item.link} target="_blank" rel="noreferrer">{item.label}</a>)
          }
        </div>
      </div>
      <PromotionProductions />
    </div>

    <div className={s.footer} style={CSS_PROPERTIES}>
      <div className={s.footerContent}>
        <Logos className={s.logos} />
        <div className={s.rules}>
          {
            SiteRules[getSite()]?.map(item => (
              <a href={item?.link} key={item?.label} target="_blank" rel="noreferrer">
                {item?.label}
              </a>
            ))
          }
        </div>

        <div className={s.copyright}>
          Copyright © 2013 -
          {' '}
          {new Date().getFullYear()}
          {' '}
          Tencent Cloud. All Rights Reserved. 腾讯云 版权所有
        </div>
        <div className={s.corporateName}>
          Tencent 腾讯旗下云平台，相关服务主体：深圳市腾讯计算机系统有限公司 | 腾讯云计算（北京）有限责任公司
        </div>
      </div>
    </div>
  </div>
);

export default PageFooter;
